import {
  AccessibleSelect,
  InputControl,
  tailwindMerge,
} from "@growtherapy/sprout-ui";

import { APPOINTMENT_LOCATION_OPTIONS } from "./constants";
import { AppointmentLocation } from "../schedule-preview/types";

interface AppointmentLocationInputProps {
  "data-testid"?: string;
  onChange: (location: AppointmentLocation) => void;
  value: AppointmentLocation;
  className?: string;
  readonly?: boolean;
}

export const AppointmentLocationInput = ({
  "data-testid": dataTestId,
  onChange,
  value,
  className,
  readonly = false,
}: AppointmentLocationInputProps): JSX.Element => {
  return (
    <InputControl
      className={tailwindMerge("w-full", className)}
      labelClassName="text-neutral-800 pt-1 text-medium font-normal"
      label="Virtual or in-person"
    >
      <AccessibleSelect
        data-testid={dataTestId}
        onChange={(newValue: string): void =>
          onChange(newValue as AppointmentLocation)
        }
        options={APPOINTMENT_LOCATION_OPTIONS}
        readonly={readonly}
        value={value}
      />
    </InputControl>
  );
};
